module.exports = __webpack_public_path__ + "static/media/warehouse_explorer_logo_v2.710a6413.svg";